export default "__VITE_ASSET__d432bae8__"